exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_wks-ext.js
// module id = 73
// module chunks = 1 2 3